import Vue from 'vue';

// 引入需要全局注册的组件
import navTop from './navbar/index.vue';

// 全局注册组件
Vue.component(navTop.name, navTop);